import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

interface App {
  package_name: string;
  platform?: string;
  [key: string]: any;
}

interface AppSelectorProps {
  control: any;
  appList: App[];
  t: (key: string) => string;
  loading?: boolean;
}

export const AppSelector = ({ control, appList, t, loading = false }: AppSelectorProps) => (
  <Controller
    name="select_app"
    control={control}
    defaultValue={null}
    render={({ field, fieldState: { error } }) => (
      <Autocomplete
        options={appList}
        getOptionLabel={(option) => {
          if (typeof option === 'string') return option;
          return option?.package_name || '';
        }}
        isOptionEqualToValue={(option, value) => {
          if (!option && !value) return true;
          if (!option || !value) return false;
          
          if (typeof value === 'string') {
            return option.package_name === value;
          }
          
          if (typeof value === 'object' && value.package_name) {
            return option.package_name === value.package_name;
          }
          
          return false;
        }}
        value={(() => {
          const currentValue = field.value;
          
          if (!currentValue) return null;
          
          if (typeof currentValue === 'object' && (!currentValue.package_name || currentValue.package_name === '')) {
            return null;
          }
          
          if (typeof currentValue === 'string' && currentValue === '') {
            return null;
          }
          
          const exists = appList.some(option => {
            if (typeof currentValue === 'string') {
              return option.package_name === currentValue;
            }
            return option.package_name === currentValue.package_name;
          });
          
          return exists ? currentValue : null;
        })()}
        onChange={(_, newValue) => {
          field.onChange(newValue);
        }}
        onBlur={field.onBlur}
        loading={loading}
        renderInput={(params) => (
          <TextField 
            {...params} 
            label={t('select_app')} 
            size="small"
            error={!!error}
            helperText={error?.message}
            InputLabelProps={{
              shrink: true,
            }}  
            placeholder={t('select_app')}
          />
        )}
        filterOptions={(options, { inputValue }) => {
          if (!inputValue) return options;
          return options.filter(option => 
            option.package_name.toLowerCase().includes(inputValue.toLowerCase())
          );
        }}
      />
    )}
  />
);